import { gql } from 'graphql-request';

export const listPracticesGql = gql`
  query listPractices(
    $limit: Int
    $offset: Int
    $filter: ListPracticesFilterParams
    $sortBy: ListPracticesSortByParams
  ) {
    listPractices(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      count
      result {
        practiceName
        partnerName
        practiceId
        partnerId
        createdAt
        updatedAt
      }
    }
  }
`;

export const createPracticeGql = gql`
  mutation createPractice($practiceInput: CreatePracticeInput!, $partnerUUID: String!) {
    createPractice(practiceInput: $practiceInput, partnerUUID: $partnerUUID) {
      practiceId
      partnerUUID
      practiceName
      address {
        line1
        line2
        city
        state
        zip
      }
      contact {
        emails
      }
    }
  }
`;

export const listPracticeProvidersGql = gql`
  query listPracticeProviders($practiceId: UUID!, $limit: Int, $offset: Int) {
    listPracticeProviders(limit: $limit, offset: $offset, practiceId: $practiceId) {
      count
      result {
        providerId
        firstName
        lastName
        middleName
        title
        phoneNumber
        npi
        dea
        createdAt
        modifiedAt
        verificationStatus
        address {
          line1
          line2
          city
          state
          zip
        }
      }
    }
  }
`;

export const validateProviderGql = gql`
  query validateProvider($input: ValidateProviderInput!) {
    validateProvider(input: $input) {
      verificationStatus
      rejectionReason
      existingProvider {
        firstName
        lastName
        middleName
        npi
      }
    }
  }
`;
